:host {
  --aha-loading-row--gap: var(--spacer-4);
  --aha-loading-row--cell-height: 1.5em;
  --aha-loading-row--horizontal-padding: 0;
  --aha-loading-row--vertical-padding: var(--spacer-3);
  --aha-loading-row--background: var(--theme-secondary-background);
  --aha-loading-row--foreground: var(--theme-tertiary-background);

  display: flex;
  flex-direction: column;
}

:host([kind='list']) {
  --aha-loading-row--vertical-padding: var(--spacer-1);
}

:host([kind='text']) {
  --aha-loading-row--vertical-padding: var(--spacer-1);
}

.row {
  display: flex;
  gap: var(--aha-loading-row--gap);
  padding: var(--aha-loading-row--vertical-padding) var(--aha-loading-row--horizontal-padding);
}

.row + .row {
  border-top: 1px solid var(--aha-loading-row--foreground);
}

:host([kind='fields']) .row + .row {
  border-top: 1px solid var(--theme-tertiary-background);
}

:host([kind='text']) .row + .row {
  border-top: none;
}

.content {
  background: var(--aha-loading-row--background);
  border-radius: var(--Common--border-radius);
  height: var(--aha-loading-row--cell-height);
  min-width: var(--aha-loading-row--cell-height);
  position: relative;
  overflow: hidden;
}
.content::before,
.content::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  background: linear-gradient(
    to right,
    transparent 0%,
    var(--aha-loading-row--foreground) 40%,
    transparent 100%
  );
  opacity: 0.5;
  min-width: 5px;
}
.content::before {
  animation: 1s linear infinite both paused translateAnim;
  width: 2rem;
  mix-blend-mode: screen;
}
.content::after {
  animation: 3s linear infinite both paused translateAnim;
  animation-delay: 0.2s;
  width: 1rem;
  mix-blend-mode: screen;
}

:host(.visible) .content::before,
:host(.visible) .content::after {
  animation-play-state: running;
}

@keyframes translateAnim {
  0% {
    right: 100%;
  }
  100% {
    right: calc(0% - 4rem);
  }
}
